export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13497.b184f251.jpg";